module.exports = __webpack_public_path__ + "img/tax.1f349f87.png";